import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/xiyangyang-gift-packs/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/xiyangyang/gift-packs',
  name: 'xiyangyang_gift_packs',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '羊村礼包大放送',
  },
}

export default [indexRoute]
